import { ToastProvider, UIProvider } from '@oppy/omniv2-ui';

import Auth0Provider from '../auth0-provider';
import QueryProvider from '../query-provider';
import RouterProvider from '../router-provider';
import UserProvider from '../user-provider';

const providers = [
  Auth0Provider,
  UserProvider,
  UIProvider,
  ToastProvider,
  QueryProvider,
  RouterProvider,
];

export default function AppProvider() {
  return providers.reduceRight(
    (prev: React.ReactNode, Provider) => <Provider>{prev}</Provider>,
    null,
  );
}
